import { render, staticRenderFns } from "./CardDetails.vue?vue&type=template&id=97493aa6&scoped=true&"
import script from "./CardDetails.vue?vue&type=script&lang=js&"
export * from "./CardDetails.vue?vue&type=script&lang=js&"
import style0 from "./CardDetails.vue?vue&type=style&index=0&id=97493aa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97493aa6",
  null
  
)

export default component.exports